import {
	array,
	boolean,
	intersect,
	literal,
	number,
	partial,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Line } from '../../../ui/geometry/Line';
import { Point } from '../../../ui/geometry/Point';

import { FrameType } from './FrameType';
import { Opening } from './Opening';
import { Segment } from './Segment';

/**
 * A frame in the HITL Frame tool.
 *
 * Extends the base Frame type from whole-house import with HITL-specific properties:
 * - `segments`: Subdivisions of the frame's polygon for fine-grained editing
 * - `movementIsLocked`: When true, brain-engine won't adjust this frame during recomputation
 *
 * Frame-level `points` was removed [ROME-8124]: Length and Inspect render from
 * `correctedPoints`, so the legacy outline is no longer read, written, ingested
 * from Brain Engine, or echoed back to it. Segment-level `points` (see
 * `Segment`) are retained: they are still rendered (Remove or Keep step), used
 * as a centreline-derivation fallback, and part of the Brain Engine contract.
 */
export const Type = intersect(
	struct({
		id: string,
		frameType: FrameType,
		isExternal: boolean,
		isLoadBearing: boolean,
		correctedCenterLine: Line,
		height: number,
		thickness: number,
		openings: array(Opening),
		segments: array(Segment),
		movementIsLocked: boolean,
		cmu: iotsUtils.withDefault(boolean, false),
	})
)(
	partial({
		topPlateRequirement: union(literal('single'), literal('double')),
		/**
		 * Junction-aware corrected outline polygon from brain-engine. The live
		 * outline maintained by local geometry edits.
		 */
		correctedPoints: array(Point),
	})
);
